import { ICard, ICustomer, IMember } from "@/interfaces/PointInterfaces";

export const MODAL_COMPONENT = {
  REDEEM_CONFIRMATION: "redeem_confirmation",
  PRE_TRANSACTION_CONFIRMATION: "pre_transaction_confirmation",
  CONFIRMATION: "confirmation",
  INSIDE_ROSTER: "inside_roster",
  OUTSIDE_ROSTER: "outside_roster",
  REDEEM_POINTS: "redeem_points",
};

export const PURCHASE_MODAL_VIEW = {
  SELECT_PACKAGE: "select-package",
  PAYMENT: "payment",
  CONFIRM: "confirm",
  REDEEM: "redeem",
};

export const CARD_CONTENT: ICard[] = [
  {
    point: 25,
    price: 25,
  },
  {
    point: 50,
    price: 50,
  },
  {
    point: 100,
    price: 100,
  },
  {
    point: 250,
    price: 250,
  },
];

export const INITIAL_MEMBER_STATE: IMember = {
  value: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
};

export const INITIAL_CUSTOMER_STATE: ICustomer = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  points: 0,
};
export const WITHDRAW_PANEL_VIEWS = {
  DEFAULT_WITH_PAYABLE_INFO: "has-payable-info",
  DEFAULT_WITH_NO_PAYABLE_INFO: "no-payable-info",
  REQUEST_INFO_CHANGE: "request-change",
  CONFIRMATION: "confirmation",
};

export const INITIAL_PAYABLE_INFO = {
  city: "",
  country: "",
  ein: 0,
  fullAddressOne: "",
  fullAddressTwo: "",
  name: "",
  payableName: "",
  payableType: "",
  region: "",
  scopeId: 0,
  street: "",
  zip: 0,
  taxDocument: "",
};
